<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-btn(raised color="primary" @click="startClosing", :disabled="!progressing || isListEmpty")
          v-icon arrow_forward
          span この内容で見積書作成に進む
        v-btn(raised color="primary" @click="continueInput" :disabled="!progressing")
          v-icon subdirectory_arrow_left
          span 見積を追加入力する。
    draggable(v-model="refBoxes" :options="{animation: 300}")
      transition-group.layout.row.wrap(name="flip-list" tag="div")
        div.flex.xs12.sm6.md4.flip-list-item(v-for="(box, index) in refBoxes" :key="box.token")
          order-list-item(:index="index")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrderListItem from './ListItem'
import draggable from 'vuedraggable'

export default {
  components: {
    OrderListItem,
    draggable
  },
  data () {
    return {}
  },
  created () {},
  computed: {
    ...mapGetters('app/order', ['isNewOrder', 'progressing', 'boxes', 'isListEmpty']),
    refBoxes: {
      get () {
        return this.boxes
      },
      set (boxes) {
        this.setBoxes(boxes)
      }
    }
  },
  methods: {
    ...mapActions('app/order', ['activateTab', 'clearBoxes', 'setBoxes']),
    startClosing () {
      this.activateTab('summary')
    },
    continueInput () {
      this.activateTab('input')
    }
  }
}
</script>

<style scoped lang="stylus">
.flip-list-item {
  &:hover {
    cursor: move;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/List.vue